import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { useTypedQuery } from "hooks";
import { XentryJobQueryKeys } from "modules/AppointmentDetails/components/CarDetails/components/XentryStatus/queryKeys";
import { ApiInstance } from "utils/Api";

type UseXentryJobsQueryProps = {
  appointmentId?: number;
};

export const useXentryJobsQuery = ({ appointmentId }: UseXentryJobsQueryProps) => {
  const { t } = useTranslation();

  const { data, isFetching, refetch } = useTypedQuery({
    queryKey: XentryJobQueryKeys.job(appointmentId),
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data.job,
    enabled: false
  });

  const fetchXentryJob = async () => {
    if (!appointmentId) return toast.error(t("v8_missing_appointment", "Missing appointment"));

    const { error } = await refetch();
    if (error) toast.error(error.message);
  };

  return { xentryJob: data, isXentryJobFetching: isFetching, fetchXentryJob };
};
